import SummaryBanner from './SummaryBanner';

export default SummaryBanner;
